var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { of, Subject } from "rxjs";
import { takeUntil, startWith, debounceTime, distinctUntilChanged, switchMap, catchError, map, } from "rxjs/operators";
var FormlyFieldTypeahead = /** @class */ (function (_super) {
    __extends(FormlyFieldTypeahead, _super);
    function FormlyFieldTypeahead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDestroy$ = new Subject();
        _this.search$ = new EventEmitter();
        _this.options$ = of([]);
        return _this;
    }
    FormlyFieldTypeahead.prototype.ngOnInit = function () {
        var _this = this;
        console.log(this.formControl);
        this.options$ = this.search$.pipe(takeUntil(this.onDestroy$), startWith(""), debounceTime(500), distinctUntilChanged(), switchMap(function (term) {
            // console.log("Termine cercato:", term);
            if (typeof _this.to.search$ !== "function") {
                // console.error("Errore: this.to.search$ non è una funzione", this.to.search$);
                return of([]);
            }
            return _this.to.search$(term).pipe(
            // tap(response => console.log("Dati ricevuti dalla ricerca:", response)),
            map(function (response) {
                if (!Array.isArray(response)) {
                    // console.warn("Typeahead sta ricevendo un valore non valido, lo resetto:", response);
                    return [];
                }
                return response;
            }), catchError(function (err) {
                // console.error("Errore API:", err);
                return of([]); // Restituisci array vuoto in caso di errore
            }));
        }));
        // this.options$.subscribe();
    };
    FormlyFieldTypeahead.prototype.ngOnDestroy = function () {
        this.onDestroy$.complete();
    };
    return FormlyFieldTypeahead;
}(FieldType));
export { FormlyFieldTypeahead };
